/**
 * Attaches to existing loading indicator markup and manages its visibility by
 * reacting to Ajax events.
 */

import Marionette from "backbone.marionette";
import Model from "../../models/loading-indicator";

const SELECTOR = ".loading-indicator";
const ACTIVITY_CLASS_NAME = "inactive";

const DEFAULTS = {
  el: SELECTOR,
  template: false,
  model: new Model(),
  modelEvents: {
    "change:active": "_onActivityChange",
  },
};

class LoadingIndicator extends Marionette.ItemView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  initialize() {
    // turn off
    this.$el.removeClass(ACTIVITY_CLASS_NAME);

    // listen to ajax requests
    $(document)
      .ajaxStart(this._start.bind(this))
      .ajaxStop(this._stop.bind(this))
      .ajaxError(this._stop.bind(this));
  }

  _onActivityChange(model, active) {
    if (active) {
      this.$el.removeClass(ACTIVITY_CLASS_NAME);
    } else {
      this.$el.addClass(ACTIVITY_CLASS_NAME);
    }
  }

  _start() {
    this.model.setActive(true);
  }

  _stop() {
    this.model.setActive(false);
  }
}

export { LoadingIndicator as default };
